import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { ScheduleActionFormData } from "./types";

type CopyToRoomProps = {
    control: Control<ScheduleActionFormData>;
    isWeekModeActive: boolean;
    resources: any;
};

export const CopyToRoom = ({ control, isWeekModeActive, resources }: CopyToRoomProps) => {
    return (
        <Controller
            name="selectedResource"
            control={control}
            render={({ field }) => (
                <FormControl fullWidth size="small" disabled={isWeekModeActive}>
                    <InputLabel id="copy-to-resource-label">Copiar para sala</InputLabel>
                    <Select
                        labelId="copy-to-resource-label"
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value as number)}
                        label="Copiar para sala"
                    >
                        <MenuItem value={0}>Manter a mesma sala</MenuItem>
                        {resources.map((resource: any) => (
                            <MenuItem key={resource.id} value={resource.id}>
                                {resource.title}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        />
    );
};
